import axios from "axios";

// Auth helper function
export const getAuthHeader = () => {
  const token = localStorage.getItem('pawsToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Axios instance with automatic auth header
export const axiosAuth = axios.create();
axiosAuth.interceptors.request.use(config => {
  const token = localStorage.getItem('pawsToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosAuth;
